import { miningPairT } from './lists.d'
export const miningList: miningPairT[] = [{
  name: 'Doughnut',
  baseAsset: 'BAKE',
  quoteAsset: 'BUSD',
  earnAsset: 'BAKE',
  icon: 'icon_doughnut.svg',
  iconLight: 'icon_doughnut_light.svg'
}, {
  name: 'Croissant',
  baseAsset: 'BAKE',
  quoteAsset: 'BNB',
  earnAsset: 'BAKE',
  icon: 'icon_croissant.svg',
  iconLight: 'icon_croissant_light.svg'
}, {
  name: 'Toast',
  baseAsset: 'BNB',
  quoteAsset: 'BUSD',
  earnAsset: 'BAKE',
  icon: 'icon_toast.svg',
  iconLight: 'icon_toast_light.svg'
}, {
  name: 'Cake',
  baseAsset: 'USDT',
  quoteAsset: 'BUSD',
  earnAsset: 'BAKE',
  icon: 'icon_cake.svg',
  iconLight: 'icon_cake_light.svg'
}, {
  name: 'Cookies',
  baseAsset: 'BNB',
  quoteAsset: 'USDT',
  earnAsset: 'BAKE',
  icon: 'icon_cookies.svg',
  iconLight: 'icon_cookies_light.svg'
}, {
  name: 'pineapple bun',
  baseAsset: 'BTCB',
  quoteAsset: 'BUSD',
  earnAsset: 'BAKE',
  icon: 'icon_pineapple_bun.svg',
  iconLight: 'icon_pineapple_bun_light.svg'
}]
